// extracted by mini-css-extract-plugin
export var body = "ArticleCard-module--body--9f441";
export var category = "ArticleCard-module--category--d9368";
export var container = "ArticleCard-module--container--24d23";
export var excerpt = "ArticleCard-module--excerpt--c19ff";
export var image = "ArticleCard-module--image--713b9";
export var isHorizontal = "ArticleCard-module--isHorizontal--bc50e";
export var isPrimary = "ArticleCard-module--isPrimary--11d0c";
export var meta = "ArticleCard-module--meta--ae80c";
export var title = "ArticleCard-module--title--bd77d";